import { useState, useRef } from "react"; // Added useRef
import { Link } from "react-router-dom";
import {
  ArrowRight,
  TextAlignJustify,
  X,
  Phone,
  MapPin,
  Clock,
  Tally1,
} from "lucide-react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import logo from "../assets/images/dr_hh_logo.png";

const NavBar = () =>  {
  const { scrollY } = useScroll();
  const [hidden, setHidden] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  // Use a ref to persist the last scroll position across renders
  const lastY = useRef(0);

  useMotionValueEvent(scrollY, "change", (latest) => {
    const diff = latest - lastY.current;

    // Hide when scrolling down, show when scrolling up
    if (diff > 5 && latest > 80) {
      setHidden(true);
    } else if (diff < -5) {
      setHidden(false);
    }
    setScrolled(latest > 40);
    lastY.current = latest;
  });
  const navLinks = [
    {
      title: "Home",
      url: "/",
    },
    {
      title: "About",
      url: "/about-me",
    },
    {
      title: "Specialities",
      url: "/specialities",
    },
    {
      title: "Blogs",
      url: "/blogs",
    },
    {
      title: "Contact",
      url: "/contact-me",
    },
  ];
  return (
    <>
      <motion.div
        initial={{ y: 0 }}
        animate={{
          y: hidden ? -200 : 0, // Moves it out of view
          // We use motion to handle the top offset for a smoother feel
        }}
        transition={{
          type: "spring",
          stiffness: 260,
          damping: 30,
        }}
        // Changed "fixed top-0" to "fixed left-0" since Framer handles "top"
        className={`fixed left-0 w-full z-20    ${scrolled ? " top-0 backdrop-blur-sm  shadow-sm bg-matcha text-white" : " top-0 bg-transparent"}`}
      >
        <div className="bg-matcha border-b border-[#B87333] text-sm font-medium text-white py-3 hidden md:flex justify-between items-center">
          <div className="xl:max-w-[1200px] mx-auto flex justify-between w-full xl:px-0 px-5 flex-row items-center  ">
            <div className="flex flex-row  gap-3 items-center">
              <div className="flex items-center gap-2">
                <Phone size={16} />
                <span>+91 98765 43210 (24/7)</span>
              </div>

              <div className="flex items-center ">
                <Tally1 size={16} />
                <MapPin size={16} />
                <span className="px-2">Hyderabad, Telangana 500084</span>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Clock size={16} />
              <span>Monday - Saturday: 9 am - 11.30 pm</span>
            </div>
          </div>
        </div>
        <div className="xl:max-w-[1200px] w-11/12 mx-auto py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src={logo} alt="Logo" className="md:h-28 h-24" />
          </Link>

          <div className="hidden lg:flex items-center xl:gap-11 gap-6 text-lg  font-semibold">
            {navLinks.map((item) => (
              <Link
                key={item.title + "UniqueLinks"}
                to={item.url}
                className="cursor-pointer hover:text-chai transition-colors"
              >
                {item.title}
              </Link>
            ))}
            <Link to="/contact-me" className={`${!scrolled ? "bg-matcha hover:text-matcha border-matcha":"bg-[#1d9e75] border-[#1d9e75] hover:text-white"} py-3 px-4 text-white text-base font-semibold border  flex items-center justify-center gap-2 rounded-md hover:bg-transparent  duration-200 transition`}>
              Appointment <ArrowRight strokeWidth={1} />
            </Link>
          </div>
          <div className="flex lg:hidden flex-row gap-4">
            <button className={`${!scrolled ? "bg-matcha ":"bg-[#1d9e75]"} py-3 lg:hidden md:flex hidden  px-4 text-white text-base font-semibold border border-[#1d9e75]  items-center justify-center gap-2 rounded-md hover:bg-transparent hover:text-white duration-200 transition`}>
              Appointment <ArrowRight strokeWidth={1} />
            </button>
            <button
              onClick={() => setOpen(true)}
              className=" text-[#1d9e75] lg:hidden    text-base font-semibold "
            >
              <TextAlignJustify strokeWidth={2} size={30} />
            </button>
          </div>
        </div>
      </motion.div>
      <div
        className={` fixed top-0 right-0 w-[320px] max-w-full h-screen bg-white z-50 shadow-2xl p-6 flex flex-col transition-all duration-500  ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Top */}
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-bold text-[#809671]">Menu</h2>

          <button
            onClick={() => setOpen(false)}
            className="w-10 h-10 rounded-full bg-[#f3eee7] flex items-center justify-center"
          >
            <X size={22} className="text-[#725c3a]" />
          </button>
        </div>
        {/* Links */}
        <div className="mt-14 flex flex-col gap-4">
          {navLinks.map((item, index) => (
            <Link
              key={"mobilescreenLinks" + index}
              to={item.url}  onClick={() => setOpen(false)}
              className="text-lg font-semibold text-[#725c3a] transition-all duration-300 hover:text-chai hover:translate-x-2  "
            >
              {item.title}
            </Link>
          ))}
        </div>
        <div className="flex flex-col gap-3 mt-5 items-start text-base font-semibold text-[#725c3a] transition-all duration-300 hover:text-chai">
          <div className="flex items-center gap-2">
            <Phone size={20} />
            <span>+91 98765 43210 (24/7)</span>
          </div>
          <div className="flex items-center ">
            <MapPin size={20} />
            <span className="ps-2">Hyderabad, Telangana 500084</span>
          </div>

          <div className="flex items-center gap-2">
            <Clock size={20} />
            <span>Monday - Saturday: 9 am - 11.30 pm</span>
          </div>
        </div>

        {/* Bottom Button */}
        <div className="mt-auto">
          <Link to='/contact-me' onClick={() => setOpen(false)} className="bg-matcha py-3 px-4 text-white text-base w-full font-semibold border border-matcha flex items-center justify-center gap-2 rounded-md hover:bg-transparent hover:text-matcha duration-200 transition">
            Appointment <ArrowRight strokeWidth={1} />
          </Link>
        </div>
      </div>
    </>
  );
}
export default  NavBar;